import React, { useState } from 'react';
import { Box, Button, Link, Alert } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../../services/auth.service';
import { AuthSplitLayout, authFooterSx } from './AuthSplitLayout';
import { AuthTextField } from './AuthTextField';

export const ForgotPasswordForm = () => {
  const { t } = useTranslation('auth');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await authService.forgotPassword({ email });
      setMessage(t('forgot.sent'));
      setEmail(''); // Clear the form
    } catch (err: any) {
      setError(err.response?.data?.message || t('forgot.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthSplitLayout
      title={t('forgot.title')}
      subtitle={t('forgot.subtitle')}
    >
      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2.25 }}>
        <AuthTextField
          type="email"
          label={t('fields.email')}
          autoComplete="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          disabled={loading}
        />
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <Button
          fullWidth
          variant="contained"
          type="submit"
          disabled={loading || !email.trim()}
          sx={{ height: 42, mt: 0.5 }}
        >
          {loading ? t('forgot.submitting') : t('forgot.submit')}
        </Button>
        <Box sx={authFooterSx}>
          <Link component={RouterLink} to="/login" underline="hover">{t('forgot.backToSignIn')}</Link>
        </Box>
      </Box>
    </AuthSplitLayout>
  );
};
